import React from 'react';
import { SelectOption } from '@spoiler-alert/ui-library';

export const listToSelected = (list) =>
  Array.isArray(list)
    ? list.map((l) => {
        if (l?.includes('meta')) return { value: l.split('.')[0], text: l };
        return { value: l, text: l };
      })
    : [];

export const listToOptions = (list, checkbox = false) => {
  if (list && list.length > 0) {
    return list.map((l) => (
      <SelectOption checkbox={checkbox} key={l} value={l}>
        {l}
      </SelectOption>
    ));
  }
  return [];
};

export const cleanModel = (model) => {
  const newModel = JSON.parse(JSON.stringify(model));
  newModel.__typename = undefined;
  newModel.importErrors = undefined;
  Object.keys(newModel).forEach((propName) => {
    if (
      typeof newModel[propName] === 'object' &&
      !Array.isArray(newModel[propName]) &&
      newModel[propName] !== null &&
      newModel[propName].__typename
    ) {
      newModel[propName].__typename = undefined;
    }
  });
  return newModel;
};

export const cleanModelDeep = (model) => {
  const newModel = JSON.parse(JSON.stringify(model));
  newModel.__typename = undefined;
  newModel.importErrors = undefined;
  const queue = Object.keys(newModel);
  while (queue.length > 0) {
    const propName = queue.shift();
    let objRef = newModel;
    const propNameList = propName.split('.');
    propNameList.forEach((pn) => {
      // noopengrep: javascript.lang.security.audit.prototype-pollution.prototype-pollution-loop.prototype-pollution-loop
      objRef = objRef[pn];
    });
    if (typeof objRef === 'object' && !Array.isArray(objRef) && objRef !== null && objRef.__typename) {
      objRef.__typename = undefined;
      const keys = Object.keys(objRef);
      keys.forEach((k) => {
        queue.push(`${propName}.${k}`);
      });
    }
  }
  return newModel;
};

export const SAVE_DELAY = 500;
